// PTC header names and values used by web banner requests.
export const ZCS_PTC_PLATFORM_HEADER = 'zappos-platform';
export const ZCS_PTC_REFERRER_HEADER = 'Referrer'; // two r's: ZCS spec, not standard HTTP
export const ZCS_PTC_PLATFORM_DESKTOP = 'desktop';
export const ZCS_PTC_PLATFORM_MOBILE_WEB = 'mobileWeb';
export const ZCS_PTC_PLATFORM_SET: ReadonlySet<string> = new Set([ZCS_PTC_PLATFORM_DESKTOP, ZCS_PTC_PLATFORM_MOBILE_WEB]);
export const ZCS_PTC_BUSINESS_UNIT_HEADER = 'zappos-business-unit';
export const ZCS_PTC_CATEGORY1_HEADER = 'zappos-category1';

// Cached banner dimensions are allowlisted and used for both forwarding and keying.

// From the txAttrFacet_Gender search facet. Same set in Kratos.
const ZCS_PTC_BUSINESS_UNIT_VALUES = ['mens', 'womens', 'unisex', 'boys', 'girls'] as const;
export const ZCS_PTC_BUSINESS_UNIT_SET: ReadonlySet<string> = new Set(ZCS_PTC_BUSINESS_UNIT_VALUES);

// Marty uses the full Cat1 enum because its value comes from the `zc1` facet.
const ZCS_PTC_CATEGORY1_VALUES = [
  'shoes',
  'clothing',
  'accessories',
  'watches',
  'home',
  'bags',
  'jewelry',
  'eyewear',
  'beauty',
  'electronics',
  'sporting goods',
  'baby essentials'
] as const;
export const ZCS_PTC_CATEGORY1_SET: ReadonlySet<string> = new Set(ZCS_PTC_CATEGORY1_VALUES);

// These classes are telemetry-only. Only allowlisted domains are forwarded and keyed.
export const ZCS_PTC_REFERRER_DIRECT = 'direct'; // blank/absent referrer
export const ZCS_PTC_REFERRER_OTHER = 'other'; // unlisted EXTERNAL site
export const ZCS_PTC_REFERRER_INTERNAL = 'internal'; // in-site nav
// `zassets.com` is Marty-only and classified as internal.
export const ZCS_PTC_REFERRER_SELF_DOMAINS: ReadonlySet<string> = new Set(['zappos.com', '6pm.com', 'zassets.com']);
// Targetable domains from the ZCS PTC Integration Guide.
const ZCS_PTC_REFERRER_DOMAIN_ALLOWLIST = [
  'google.com',
  'bing.com',
  'amazon.com',
  'capitaloneshopping.com',
  'yahoo.com',
  'duckduckgo.com',
  'bravodeal.com',
  'facebook.com',
  'rakuten.com',
  'msn.com',
  'brave.com',
  'instyle.com',
  'rankandstyle.com',
  'cnn.com',
  'fatcoupon.com',
  'topcashback.com',
  'couponfollow.com',
  'youtube.com',
  'retailmenot.com'
] as const;
export const ZCS_PTC_REFERRER_DOMAIN_SET: ReadonlySet<string> = new Set(ZCS_PTC_REFERRER_DOMAIN_ALLOWLIST);
